import Highcharts from 'highcharts/highcharts';

window.Highcharts = Highcharts;